import React from 'react';

class CircleBar extends React.Component {

    state = {
        progress: 0
    }


    componentDidMount() {
        this.timerID = setInterval(() => {
            let { progress } = this.state;
            let { percent } = this.props;
            // console.log('percent', percent)
            // console.log('percent', progress < percent)
            if (progress < percent) {
                this.setState(prevState => ({
                    progress: prevState.progress + 1
                }));
            } else {
                clearInterval(this.timerID);
            }
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    render() {
        const { progress } = this.state;
        const radius = 25;
        const circumference = 2 * Math.PI * radius;
        const offset = circumference - (progress / 100) * circumference;

        return (
            <div className='position-relative' style={{ width: "max-content" }}>
                <svg
                    className="progress-bar " width="59" height="59" style={{ position: 'relative' }}>
                    <circle className="progress-bar__background" cx="29" cy="29" r={radius}
                        style={{ fill: 'none', stroke: '#e5e5e5', strokeWidth: '8px' }} />
                    <circle className="progress-bar__progress" cx="29" cy="29" r={radius}
                        style={{ fill: 'none', stroke: this.props.color, strokeWidth: '8px', strokeDasharray: circumference, strokeDashoffset: offset, strokeLinecap: 'round' }}
                    />
                </svg>
                <div className='position-absolute ' style={{ top: '33%', left: '26%', color: "#222", fontSize: 14 }}>{progress}%</div>
            </div>
        );
    }
}

export default CircleBar;